export default {
  id: 'permissions',
  title: 'Permissions Management',
  category: 'Admin',
  summary: 'Create roles and assign permissions that control which menus and actions users can access.',
  overview: 'Timeclerk authorization is role-based. Roles bundle permissions (PERM_*) that gate navigation items, pages, and sensitive actions.',
  howItWorks: [
    'Administrators define roles such as employee, manager, or accounting.',
    'Permissions are added to roles to grant specific capabilities.',
    'Employees are associated with roles; missing permissions hide menu items and block routes.'
  ],
  actions: [
    {
      name: 'Add role',
      description: 'Creates a new role that can later receive permissions and be assigned to users.'
    },
    {
      name: 'Edit role',
      description: 'Updates role details. Some system role names may not be editable.'
    },
    {
      name: 'Add permissions',
      description: 'Attaches one or more permission grants to the selected role, expanding what those users can do.'
    }
  ],
  tips: [
    'Grant least privilege — only add permissions required for the job.',
    'If a user cannot see a page you expect, check both their role membership and the role’s permissions.'
  ],
  related: ['employees', 'settings']
};



// WEBPACK FOOTER //
// ./client/help/content/permissions.js